import { DocumentCard, DocumentCardImage, ImageFit } from "@fluentui/react";
import { baseUrlUser } from "../../../constants/url.constant";
import { MyTooltip } from "../../common/views/MyTooltip";
import { Utils } from "../../common/views/Utils";
import { emptyFunc } from "../../home/models/OtherTypes";
import { PictureModel, FileType, FileCategory } from "../../pictures/models/PictureModel";
import { ProductModel } from "../models/ProductModel";
import { ShortWebsiteModel } from "../../websites/models/WebsiteModel";

export type productFunc = (product: ProductModel) => void;
export type websitesCallback = (list: ShortWebsiteModel[]) => void;

export class ProductUtils {
    public static getImageUrl(baseUrl: string, picture?: PictureModel) {
        return picture && !Utils.isNullOrEmpty(picture.imageUrl) ? baseUrl + picture.imageUrl : "";
    }

    public static printInfo(product: ProductModel): JSX.Element {
        return <div style={{ fontSize: "small" }}>
            {!Utils.isNullOrEmpty(product.name) && <div className="pt-5">
                <div className="product-name">{product.name}</div>
            </div>}
            {!Utils.isNullOrEmpty(product.description) && <div className="pt-5">
                <div className="product-name">{product.description}</div>
            </div>}
        </div>;
    }

    public static createMediaView(fileType: FileType, url: string, size: any): JSX.Element {
        let element = <></>;

        if (fileType === FileType.video) {
            element = <video style={{ maxWidth: "100%", maxHeight: "100%" }}
                controls><source src={url} type="video/mp4" /></video>;
        } else if (fileType === FileType.others) {
            element = <a href={url} target="_blank">pdf</a>;
        } else {
            if (Utils.isNull(size)) {
                size = Utils.pictureFileSizes["Mobile"];
            }

            element = <>
                <DocumentCardImage
                    imageFit={ImageFit.centerCover}
                    className="product-picture image-radius"
                    imageSrc={url}
                    height={size.height}
                />
            </>;
        }

        return element;
    }

    public static createImageView2(
        type: FileType,
        url: string,
        category: FileCategory,
        size: any,
        onClick: emptyFunc
    ): JSX.Element {
        if (!size && !Utils.isNull(category)) {
            size = Utils.pictureFileSizes[FileCategory[category].toString()];
        }

        if (Utils.isNullOrEmpty(url)) return <></>;

        return <>
            <DocumentCard
                onClick={onClick}
                className="picture-wrapper pb-10"
                styles={{ root: { maxWidth: "100%" } }}
                style={{ width: "100%", minWidth: "100%" }}
            >
                {this.createMediaView(type, url, size)}
            </DocumentCard>
        </>;
    }

    public static getMiniPicture(
        type: FileType,
        url: string,
        text: string,
        onClick: emptyFunc,
        width = 50
    ): JSX.Element {
        if (type === FileType.video) {
            url = "/dist/vendor/video.png";
        } else if (type === FileType.others) {
            url = "/dist/vendor/file.png";
        }

        if (Utils.isValidUrl(baseUrlUser + url)) {
            url = baseUrlUser + url;
        }

        const element = <>
            <DocumentCardImage
                width={width}
                height={width}
                imageFit={ImageFit.centerCover}
                className="mini-product-picture"
                imageSrc={url}
                styles={{ centeredIcon: { zIndex: 100 } }}
            />
        </>;

        return <>
            <DocumentCard
                onClick={onClick}
                className="mini-picture-wrapper"
                style={{ width: width + 8, minWidth: width + 8 }}
            >
                {!Utils.isNullOrEmpty(text) && <MyTooltip element={element} text={text} />}
                {Utils.isNullOrEmpty(text) && element}
            </DocumentCard>
        </>;
    }

    public static getLargePicture(type: FileType, url: string, onClick: emptyFunc): JSX.Element {
        if (Utils.isNullOrEmpty(url)) return <></>;

        return <>
            <DocumentCard
                onClick={onClick}
                className="picture-wrapper"
                styles={{ root: { maxWidth: "100%", height: 480, textAlign: "center" } }}
            >
                {this.getMedia(type, url)}
            </DocumentCard>
        </>;
    }

    public static getMedia(fileType: FileType, url: string): JSX.Element {
        if (Utils.isValidUrl(baseUrlUser + url)) {
            url = baseUrlUser + url;
        }

        let element = <></>;

        if (fileType === FileType.video) {
            element = <>
                <video
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                    controls
                >
                    <source src={url} type="video/mp4" />
                </video>
            </>;
        } else if (fileType === FileType.others) {
            element = <a href={url} target="_blank">pdf</a>;
        } else {
            element = <>
                <img
                    src={url}
                    alt=""
                    className="image-radius"
                    style={{
                        width: "auto",
                        height: "auto",
                        maxWidth: "100%",
                        maxHeight: 475
                    }}
                />
            </>;
        }

        return element;
    }
}